import { ICheekSwabRequestValidation } from './cheek-swab-request-validation';

interface IState {
    [index: string]: string | boolean | ICheekSwabRequestValidation,
    firstName: string,
    lastName: string,
    address1: string,
    address2: string,
    city: string,
    state: string,
    postalCode: string,
    contactPhone: string,
    email: string,
    dob: string,
    dirty: boolean,
    validation: ICheekSwabRequestValidation,
    message: string
}

const initialState: IState = {
    firstName: '',
    lastName: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    postalCode: '',
    contactPhone: '',
    email: '',
    dob: '',
    dirty: false,
    validation: {
        firstName: true,
        lastName: true,
        address1: true,
        address2: true,
        city: true,
        state: true,
        postalCode: true,
        contactPhone: true,
        email: true,
        dob: true
    },
    message: ''
}

const cheekSwabReducer = (myState: IState, action: { type: string, payload: any }): IState => {
    if (action.type == 'reset') {
        return { ...action.payload };
    }
    
    if (action.type == 'afterGetData') {
        let { firstName, lastName, address1, address2, city, state, postalCode, contactPhone, email, dob } = action.payload;
        return { ...myState, firstName, lastName, address1, address2, city, state, postalCode, contactPhone, email, dob };
    }

    if (action.type == 'inputChange') {
        myState[action.payload.name] = action.payload.value;
        return { ...myState };
    }

    if (action.type == 'submit') {
        return { ...myState, validation: action.payload.validation, dirty: action.payload.dirty };
    }

    if (action.type == 'updateMessage') {
        return { ...myState, message: action.payload };
    }

    return { ...myState };
}

export { IState, initialState, cheekSwabReducer };